import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/license/:id',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/LicenseContainer',
      './modules/License'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const License = require('./containers/LicenseContainer').default
      const actions = require('./modules/License')
      const reducer = require('./modules/License').default
      const auth = require('components/Auth')

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'license', reducer: reducer })

      store.dispatch(auth.addStorageListener())
      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.id, nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, License)

    /* Webpack named bundle   */
    }, 'License')
  }
})



// WEBPACK FOOTER //
// ./src/routes/License/index.js